"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
/**
 * Read Blob file as a base64 string
 * @param  {Blob}    file The Blob file instance to read
 * @return {Promise}      A reader promise
 */
function readBlobFile(file) {
  function promiseHandler(resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function onReadEnd() {
      if (reader.error) return reject(reader.error);
      return resolve(reader.result);
    };
    return reader;
  }

  return new Promise(promiseHandler);
}

exports.default = readBlobFile;


// WEBPACK FOOTER //
// ../node_modules/react-lazy-image/build/read-blob-file.js